import I18n from "i18n-js"
import React from "react"

class DocumentFormCompletion extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="OrderFormBuilder" ref="form" style={{paddingTop: '15px'}}>   
        <div className="sign-in-container">
          <div className="row center_1">
            <div className="text-center col-md-12">
              <img className="logo_image" src={this.props.logo_image_url} style={{width: 200, height: 'auto', marginBottom:'10px'}}></img> 
            </div>
          </div>
          <div className="row center_1">
            <div className="text-center col-md-12">
              <label className="label_style">{this.props.property_name}</label>
            </div>
          </div>
          <div className="row center_1">
            <div className="text-center col-md-12">
              <label className="label_style">{this.props.property_address}</label>
            </div>
          </div>
          <div className="row center_1">
            <div className="text-center col-md-12">
              <label className="label_style">{`${this.props.property_city}, ${this.props.property_state} ${this.props.property_postal_code}`}</label>
            </div>
          </div>

          <div className="row center_1" style={{width: '100%'}}>
            <div className="text-center col-md-12">
              <label className="label_style" style={{fontSize:'11px'}}>{`${I18n.t('main')}: `}<span><p className="label_style" style={{display: "inline"}}>{this.props.property_phone}</p></span></label>
            </div>
          </div>

          <div className="row center_1" style={{width: '100%'}}>
            <div className="text-center col-md-12">
              <label className="label_style" style={{fontSize:'11px'}}>{`${I18n.t('email')}: `}<span><p className="label_style" style={{display: "inline"}}>{this.props.property_email}</p></span></label>
            </div>
          </div>
          <hr style={{marginTop: '3px', marginBottom: '7px'}} />

          <form style={{position: "relative"}}>
            <div className="set-password-form">
              <label className="password-rules-label" style={{textTransform: 'uppercase', fontSize:'13px'}}>{I18n.t('submission_has_been_sent')}</label>
            </div>
          </form>
        </div>    
      </div>
    )
  }

}

export default DocumentFormCompletion